import React, { useEffect, useState } from 'react'
import style from "./CompanyProfile.module.css";
import templateStyles from "../DashBoard/Templates/Templates.module.css"
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper';
import IssuerNavigator from '../../components/DashBoard/IssuerNavigator';
import ShimmerLoader from '../../components/ShimmerLoader';
import API from "../../ApiConfig";
import { LAST_PUBLISHED_RECORD_BY_ISSUER } from '../../Utils/constant';
import cogoToast from 'cogo-toast-react-17-fix';
import { convertDateFormat, setDate } from '../../Utils/helper';
import Pagination from './ExternalDash/Pagination';
import Loader from '../../components/Loader';
import { Link } from 'react-router-dom';
import Icon from 'react-icons-kit';
import { androidOpen } from 'react-icons-kit/ionicons/androidOpen';
const Reports = () => {

  const [loading, setLoading]=useState(false)
  const [ search, setSearch]=useState("")
  const [currentPage, setCurrentPage]=useState(1)

  const [totalPages, setTotalPages]=useState(1)


  const [currentRecords, setCurrentRecords]=useState([])
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })

  const getReport=()=>{
    setLoading(true)
    const params = {
      page: currentPage,
      search: search
    };
    if (dateRange?.startDate && dateRange?.endDate) {
      params.start_date = convertDateFormat(dateRange.startDate);
      params.end_date = dateRange.endDate
        ? convertDateFormat(dateRange.endDate)
        : convertDateFormat(dateRange.startDate);
    }
    API.get(LAST_PUBLISHED_RECORD_BY_ISSUER,{params})
    .then(res=>{
      setLoading(false)
      setCurrentRecords(res.data.data.records)
      setTotalPages(res.data.data.pagination.total_pages)
      
    })
    .catch(err=>{
      setLoading(false)
      cogoToast.error(err.response.data.message)
    })
  }
  const handleDateChange = (field, e) => {
    setDateRange((prev) => ({ ...prev, [field]: e }));
  }
  useEffect(()=>{
    const debounce=setTimeout(()=>{
      getReport()
    },300)
    return ()=> clearInterval(debounce)
  },[currentPage, search, dateRange.endDate, dateRange.startDate])
  useEffect(()=>{
    setCurrentPage(1)
  },[])
  const handleSearch=(e)=>{
    setSearch(e)
    setCurrentPage(1)
  }


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  }
  function formatDate(dateStr) {
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year:"numeric"
    });
  }
  return (
    <SlideUpWrapper direction='slide-left'>
             <div
            className={[style.companyProfile, templateStyles.templateHeader].join(
              " "
            )}
          >
            <Loader isOpen={loading}/>
            <IssuerNavigator
              title="Reports"
              actions={() => <></>}
              step={"/"}
            />
          </div>

          <div style={{ margin: "1rem", height:"100vh" }}>                    
                    <div className={style.searchContainer}>
                              <div className="inputField2">
                                <div className="input1">
                                  <div className="content1">
                                    <img
                                      className="searchOutlineIcon1"
                                      alt=""
                                      src="/searchoutline.svg"
                                    />
                                    <input
                                      value={search}
                                      onChange={(e) => handleSearch(e.target.value)}
                                      className="inputText1"
                                      placeholder="Search"
                                    />
                                  </div>
                                </div>
                              </div>


                              <div className="exportRecords">
            <input
              type="date"
              className={style.datePicker}
              value={dateRange.startDate}
              style={{ margin: "10px 25px 0px 25px" }}
              onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
            />
            <input
              type="date"
              className={style.datePicker}
              value={dateRange.endDate}
              style={{margin:"10px 25px 0px 25px"}}
              onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
            />

            </div>
                    </div>

                    <div style={{marginTop:"1rem"}}>
                      <div className="credentials-table">
                              <table style={{ borderRadius: "10px" }}>
                                <tr className="credentials-header bg-lgray">
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Company Name</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Last Published Date</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Last Published Count</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Total Published Records</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Total Pending Records</div>
                                  </th>
                      
                      
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Total Revoked Records</div>
                      
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Action</div>
                      
                                  </th>
                                </tr>
                                {loading ? (
                                  <>
                                    <tr className="credentials-tr">
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                ) : currentRecords.length === 0 ? (
                                  <tr className="credentials-tr">
                                    <td colSpan="6" className="credentials-td text-center">
                                      <div className="Data_List">No Records</div>
                                    </td>
                                  </tr>
                                ) : (
                                  <>
                                    {currentRecords.map((i, index) => {
                                      return (
                                        <tr
                                          className="credentials-tr"
                                          style={{ animationDelay: `${index * 0.1}s` }}
                                        >
                                          <td className="credentials-td" style={{justifyContent:"start"}}>
                                            <div
                                              className="credentials-table-text1"
                                              style={{ display: "flex", alignItems: "center" }}
                                            >
                                              <div>{i.company_name}</div>
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div
                                              className="credentials-table-text1"
                                              style={{ display: "flex", alignItems: "center" }}
                                            >
                                              <div>{i.last_published_date ?formatDate(i.last_published_date):"NA"}</div>
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div
                                              className="credentials-table-text1"
                                              style={{ display: "flex", alignItems: "center" }}
                                            >
                                              <div>{i.last_published_count}</div>
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div className="credentials-table-text1" style={{textAlign:"center"}}>
                                              {i.total_published_records}
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div className="credentials-table-text1">
                                              {i.total_pending_records}
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div className="credentials-table-text1" style={{textAlign:"center"}}>
                                              {i.total_revoked_records}
                                            </div>
                                          </td>
                                          <td className="credentials-td Action-row">
                                          <div className="eye-icon" >
                                                                 <Link to={`/issued_data_details/${i.company_id}`} state={{company_name:i.company_name}} className="link">
                                                                    <Icon icon={androidOpen} size={'1rem'} />
                                                                    View
                                                                  </Link>
                                                                </div>
                                          </td>
                                              </tr>
                                              );
                                            })}
                                            </>
          )}
        </table>
                    </div>
                    </div>
                    <div style={{ margin: "10px" }}>
          <Pagination
            nPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div>
                    </div>
        </SlideUpWrapper>
  )
}

export default Reports